import React from 'react';
import cx from 'classnames';

import TextAccordion, { TextAccordionProps } from '../TextAccordion';
import TypographySwitcher from '../TypographySwitcher';
import { Tag } from '../Typography';

import styles from './index.module.scss';

export interface PriceBlockProps {
  eyebrow?: string;
  listItems?: TextAccordionProps[];
  totalLabel: string;
  totalPrice: string;
}

const PriceBlock: React.FC<PriceBlockProps> = ({
  eyebrow,
  listItems,
  totalLabel,
  totalPrice,
}) => {
  return (
    <div className={styles.wrapper}>
      {eyebrow && <Tag className={styles.eyebrow}>{eyebrow}</Tag>}
      {listItems && listItems.length > 0 && (
        <ul className={styles.list}>
          {listItems.map((item, index) => (
            <TextAccordion key={index} {...item} />
          ))}
        </ul>
      )}
      <div
        className={cx(styles.totalPriceWrapper, {
          [styles.withoutEyebrowAndList]: !eyebrow && !listItems?.length,
        })}
      >
        <TypographySwitcher
          className={styles.totalLabel}
          mobile='subtitle2'
          tablet='subtitle1'
          desktop='subtitle1'
        >
          {totalLabel}
        </TypographySwitcher>
        <TypographySwitcher
          className={styles.totalPrice}
          mobile='subtitle2'
          tablet='subtitle1'
          desktop='subtitle1'
        >
          {totalPrice}
        </TypographySwitcher>
      </div>
    </div>
  );
};

export default PriceBlock;
